document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.products-carousel').forEach(function (carouselEl) {
    new Swiper(carouselEl.querySelector('.products-swiper'), {
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: carouselEl.querySelector('.products-swiper-next'),
        prevEl: carouselEl.querySelector('.products-swiper-prev')
      },
      pagination: {
        el: carouselEl.querySelector('.products-swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        750: { slidesPerView: 2 },
        1025: { slidesPerView: 3 }
      },
      touchRatio: 1,
      grabCursor: true
    });
  });
});